import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { CrudOrgComponent } from '../../features/crud-organisation/crud-org.component';
import { ObCreateOrgFacade, ObCreateOrgUiState } from './ob_create_org.facade';
import { Subscription } from 'rxjs';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';

@Component({
    selector: 'app-ob-create-org',
    imports: [...COMMON_IMPORTS, DialogModule, CrudOrgComponent],
    templateUrl: './ob_create_org.component.html',
    styleUrls: ['./ob_create_org.component.css']
})
export class ObCreateOrgComponent implements OnInit, OnDestroy {
  state: ObCreateOrgUiState = 'idle';
  showDialog = false;
  private sub = new Subscription();

  constructor(private facade: ObCreateOrgFacade) {}

  ngOnInit(): void {
    this.sub.add(this.facade.state$.subscribe((state) => (this.state = state)));
    this.facade.start();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  openDialog() {
    this.showDialog = true;
  }

  closeDialog() {
    this.showDialog = false;
  }

  createOrg() {
    this.facade.createOrg();
  }

  goToDashboard() {
    this.facade.goToDashboard();
  }

  signOut() {
    this.facade.signOut();
  }
}
